import React, {Fragment, useState} from 'react';
import {Form,Button,Spinner,Image} from 'react-bootstrap';
import axios from 'axios';
import logo from '../../img/logo_uam.png';
import AlerteMessage from '../../components/AlerteMessage';
import Input from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import RecepisseVote from '../../components/RecepisseVote';
// import Pay from '../pay/Pay';
// import PayUniforme from '../PayUniforme/Pay';
import { useRef } from 'react';
import './vote.css';
import Env from '../../hooks/Env';

// Informations des listes de candidats (élection représentant des étudiants, Cycle Licence).
// Gardées côté frontend uniquement, associées par email de candidat.
const LISTES_INFO = {
    'kwasan.benzamin@uam.edu.sn': {
        liste: 'Liste ESSOR (Engagement, Solidarité, Stratégie, Ouverture et Réussite)',
        suppleant: 'Ndèye Fatou CISSÉ',
    },
    'diongue.abdoulaye@uam.edu.sn': {
        liste: 'Liste PACTE (Progrès Action Collaboration Transparence et Excellence)',
        suppleant: 'Ndèye Maty FALL',
    },
};

const Vote = ({props}) => {
    const { API_URL } = Env();
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [open, setOpen] = useState (false)
    const [message, setMessage] = useState (false)
    const [errMsg, setErrMsg] = useState('');
    const errRef = useRef();
    const [auth, isAuth] = useState(false)
    const [infos, setInfos] = useState([]);
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedOptions, setSelectedOptions] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleSubmit = async (e) => {
        if (!auth) {
            console.log('pas authentifié ')
            const formData = new FormData();
            formData.append('email', user)
            formData.append('codePermanent', pwd)
            // console.log(formData)
            try {
                const response = await axios.post(
                    `${API_URL}/vote/auth`,
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
                if (response.status===200) {
                    isAuth(true)
                    setInfos(response.data)
                    console.log(infos)
                    
                }
                console.log(response.data)
            } catch (error) {
                console.log(error.response)
                setSubmitted(false);
                setOpen(true)
                setMessage(error.response.data.detail)
            }
        } else {
            try {
                e.preventDefault();
                console.log(selectedOptions);
                const formData = new FormData();
                formData.append('email',user)
                formData.append('codePermanent',pwd)
                if (selectedOptions) {
                    formData.append('candidat1', selectedOptions.value)
                }
             for (let pair of formData.entries()) {
                    console.log(pair[0] + ':' + pair[1]);
                  }
                if (valid.isValidPhoneNumber) {
                    console.log("pas valide")
                }
                else if (!selectedOptions) {
                    setOpen(true)
                    setMessage('Vous devez choisir un candidat')
                    return;
                }
                else {
                    setComplete(true)
                    setSubmitted(true);
                    // console.log("Requete en cours d'envoi ...")
                    const response = await axios.post(
                        `${API_URL}/vote/`,
                        formData,
                {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                        });
                console.log(response)
                if (response.status === 200) {
                    if (response.data.detail) {
                        setSubmitted(false);
                        setDeppotSuccess2(true)
                    } else {
                        setSubmitted(false);
                        const dataPersonDepot = response?.data?.data;
                        setData(dataPersonDepot);
                        setDeppotSuccess(true);
                    }
                } else {
                    console.error('Error uploading files');
                    console.log("Détail de la réponse ",response.status)
                }
            }
        } catch (error) {
            setSubmitted(false);
           console.error('Error', error);
        }
    }

};
    const handleSelectChange = (selected) => {
        setSelectedOptions(selected);
    };
    const selectCandidat = (candidat) => {
        handleSelectChange({
            value: candidat.email,
            label: `${candidat.prenom} ${candidat.nom}`,
        });
    };
    const getInitials = (candidat) =>
        `${candidat.prenom?.[0] || ''}${candidat.nom?.[0] || ''}`.toUpperCase();
    const candidatOptionsAvailable = Array.isArray(infos) && infos.length > 0;
    const handleClose3 = () => {
        setOpen(false)
    }
  return (
    <>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        {/* {errors ? <Alert3 message = 'Vous devez faire la préinscription en ligne avant de compléter votre dossier' /> : null } */}
        <Alert show={show} handleClose={handleClose} />
        {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
        {depotsuccess ? <RecepisseVote  dataPerson={data}/> : null}
        <div>
            <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
            </div>
            {/* {aprés authentification} */}
            {auth ?
            <>
              <div className='container mb-4 vote-container' id='mainDepot'>
              <div id='nameModule' className='vote-header'>
                  <Image src={logo} width={60} height={66} className="mb-2" />
                  <p className="vote-title">Vote de délégué UAM</p>
                  <p className="vote-subtitle">Sélectionnez le candidat pour lequel vous souhaitez voter, puis cliquez sur « Valider ». Votre choix est définitif et unique.</p>
              </div>
              <div id="form" className='inscription'>
                  <Form onSubmit={handleSubmit}>
                  <div id="step1" className='mb-3'>
                      <Input type='email' readOnly={true} className='' value={user || ''} required={false}   label="Adresse mail" name='email'/>
                      <Input type='codePermanent' readOnly={true} className='mb-2' value={pwd || ''} required={false}   label="Code Permanent" name='email'/>
                      <Input type='' readOnly={true} className='mb-2' value={infos[0]?.etablissement?.toUpperCase() || ''} required={false}   label="Etablissement" name='etablissement'/>
                      <div className='row' id='test'>
                      </div>
                    {candidatOptionsAvailable ? (
                        <div className="candidat-grid">
                            {infos.map((candidat) => {
                                const isSelected = selectedOptions?.value === candidat.email;
                                const listeInfo = LISTES_INFO[candidat.email];
                                return (
                                    <div
                                        key={candidat.email}
                                        className={`candidat-card${isSelected ? ' selected' : ''}`}
                                        onClick={() => selectCandidat(candidat)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        <div className="candidat-avatar">{getInitials(candidat)}</div>
                                        <div className="candidat-name">{candidat.prenom} {candidat.nom}</div>
                                        <div className="candidat-meta">
                                            {candidat.codePermanent}{candidat.niveau ? ` · ${candidat.niveau}` : ''}
                                        </div>
                                        {listeInfo && (
                                            <>
                                                <div className="candidat-liste">{listeInfo.liste}</div>
                                                <div className="candidat-suppleant">Suppléant(e) : {listeInfo.suppleant}</div>
                                            </>
                                        )}
                                        <div className="candidat-check">{isSelected ? '✓ Choisi' : 'Choisir'}</div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <p className="text-muted">Aucun candidat disponible pour votre établissement pour le moment.</p>
                    )}
                  </div>
                  <div className="buttons">
                  <Button  variant="primary" type='submit' size="md"
                  className="p-2 float-end mb-2">
                      Valider  {submitted ?
                          <Spinner animation="grow"
                          size="sm" role="status"
                          >
                          <span className="visually-hidden">Loading...</span>
                          </Spinner>
                          : null}
                  </Button>
                  </div>
                  </Form>
              </div>
          </div>
             }

            </>
            : <Form onSubmit={handleSubmit} style={{display:"inline-block"}}>
                <p ref={errRef} className={errMsg ? "errMsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                <div className="row container border border-primary depotdossier" id="test">
                    <div id="bodyForm">
                        <div>
                        <p><Image src={logo} width={90} height={100} /> <br /> <b>Vote de délégué UAM</b></p>
                        </div>
                        <Form.Group className="col-12" controlId="formBasicEmail">
                            <Form.Label className=''><h5>Email institutionnelle : </h5></Form.Label>
                            <Form.Control
                                    type="email"
                                    name="email"
                                    value = {user}
                                    onChange={(e) => setUser(e.target.value)}
                                    placeholder="Enter email"
                                    required
                                />
                        </Form.Group>
                        <Form.Group className="col-12" controlId="formBasicPassword">
                            <Form.Label className=''><h5>Code Permanent : </h5></Form.Label>
                                <Form.Control
                                        type="codepermanent"
                                        name="codepermanent"
                                        value={pwd}
                                        onChange={(e) => setPwd(e.target.value)}
                                        placeholder="123456"
                                        required  
                                    />
                        </Form.Group>
                    </div>
                    <div>
                        <Button
                            variant="success"
                            id="test"
                            className="btn-xl float-start"
                            style={{margin:'9px'}}
                            onClick={handleSubmit}
                            >
                            Voter {submitted ? <Spinner animation="grow" size="sm" role="status" /> : null}
                        </Button>
                    </div>
                </div>
            </Form>}
        </div>
    </>
  )
}
export default Vote
